<script setup lang="ts">
import FormTextInput from '@/core/forms/FormTextInput.vue';
import EntityAppearancePicker from '@/core/entity-appearance/EntityAppearancePicker.vue';
import type { TEntityAppearance } from '@/core/entity-appearance/entityAppearance.types';
import { useTemplateRef } from 'vue';
import {
  CLASS_OR_GROUP_NAME_MAX_LENGTH,
  CLASS_OR_GROUP_NICKNAME_MAX_LENGTH,
} from 'common/constants/school.class.constants';

defineProps<{
  nameField: string;
  name?: string;
  abbreviationField: string;
  abbreviation: string;
  nameOptional?: boolean;
}>();
const appearance = defineModel<TEntityAppearance>('appearance', { required: true });
const picker = useTemplateRef('picker');
defineExpose({ closeAppearance: () => picker.value?.close() });
</script>

<template>
  <div class="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-sm md:grid-cols-[minmax(0,1fr)_104px_auto] md:gap-md">
    <FormTextInput
      class="col-span-2 min-w-0 md:col-span-1"
      :name="nameField"
      :value="name"
      :label="nameOptional ? $t('classes.optionalName') : $t('general.name')"
      :max-length="CLASS_OR_GROUP_NICKNAME_MAX_LENGTH"
    />
    <FormTextInput
      :name="abbreviationField"
      :value="abbreviation"
      :label="$t('groups.abbreviation')"
      :max-length="CLASS_OR_GROUP_NAME_MAX_LENGTH"
    />
    <EntityAppearancePicker ref="picker" v-model="appearance" :abbreviation="abbreviation" />
  </div>
</template>
